import { PaginatedCollection, directusApi } from '@/api';
import { asyncForEach, validateFileName } from '@/utils';
import lodash from 'lodash';

export interface Product {
    // sku: string;
    qty: string;
    discount: string;
    id: string;
    title: string;
    post_type: string;
    stock: string;
    price: string;
    warehouses: Array<any>;
    description: string;
    name?: string;
}
export interface Catalog {
    id?: number;
    title?: string;
    subtitle?: any;
    image?: any;
}

export interface CatalogState {
    activeCatalog: Catalog | null;
    activeCatalogLoading: boolean;
    allCatalogs: Array<Catalog>;
    allCatalogsLoading: boolean;
    catalogsPerPage: number;
    catalogsPage: number;
    catalogsTotal: number;
}

const defaultCatalog = {
    id: 0,
    title: '',
    subtitle: [],
    image: []
};

const state: CatalogState = {
    activeCatalog: defaultCatalog,
    activeCatalogLoading: false,
    allCatalogs: [],
    allCatalogsLoading: false,
    catalogsPerPage: 1,
    catalogsPage: 1,
    catalogsTotal: 1,
};

const mutations = {
    toggleallCatalogsLoading(state: CatalogState, data: boolean) {
        state.allCatalogsLoading = data;
    },
    setAllCatalogs(state: CatalogState, data: PaginatedCollection) {
        state.allCatalogs = data.items;
        state.catalogsPerPage = data.perPage;
        state.catalogsPage = data.currentPage;
        state.catalogsTotal = data.totalItems;
    },
    toggleActiveCatalogLoading(state: CatalogState, data: boolean) {
        state.activeCatalogLoading = data;
    },
    setActiveCatalog(state: CatalogState, data: Catalog) {
        state.activeCatalog = data;
    },
    removeCatalog(state: CatalogState, id: number) {
        state.allCatalogs = lodash.remove(state.allCatalogs, function (n) {
            return n.id != id;
        });
    },

};

const actions = {
    async postOne({ _, commit, dispatch }: any, { catalog }: any) {
        commit('toggleActiveCatalogLoading', true);

        let catalogEndpoint: string = 'items/catalogs';
        let catalogMethod: any = 'POST';

        if (catalog.data.id != 0) {
            catalogMethod = 'PATCH';
            catalogEndpoint = `items/catalogs/${catalog.data.id}`;
        }

        await directusApi(catalogMethod, catalogEndpoint, {
            title: catalog.data.title,
            subtitle: catalog.data.subtitle,
            image: catalog.data.image[0] || [],
        })
            .then(async (catalogg: any) => {
                let image = [];
                catalog.data.image == null ? (image = []) : (image = catalog.data.image);
                let complete_gallery = catalog.data.complete_gallery;

                try {
                    if (catalog.data.image[0].origin == 'upload') {
                        let imageNameValidation = await validateFileName(catalog.data.image[0].name);
                        if (imageNameValidation == 0) {
                            await directusApi('POST', `files`, catalog.data.image[0].file)
                                .then(async (resFile: any) => {
                                    image = [
                                        {
                                            id: resFile.data.data.id,
                                            sort: catalog.data.image[0].sort,
                                            url: `https://directus.prodelec.app/assets/${resFile.data.data.id}`,
                                            origin: 'directus',
                                            name: resFile.data.data.title,
                                            // origin: catalog.data.image[0].origin,
                                            file: catalog.data.image[0].file
                                        }
                                    ];
                                    await asyncForEach(complete_gallery, async (complete_gallery_item, complete_gallery_index) => {
                                        console.log('posting rezising file :D');
                                        if (complete_gallery_item.origin != 'directus') {
                                            await directusApi('POST', `files`, complete_gallery_item.file)
                                                .then(async (resFile: any) => {
                                                    if (catalog.data.image[0].hasOwnProperty('alt')) {
                                                        await directusApi('PATCH', `files/${resFile.data.data.id}`, { alt: catalog.data.image[0].alt })
                                                            .then(async (resFile: any) => {
                                                                console.log('Alt added to complete gallery');
                                                            })
                                                            .catch(err => {
                                                                console.log(err);
                                                            });
                                                    }
                                                    complete_gallery[complete_gallery_index] = { id: resFile.data.data.id, sort: null, name: resFile.data.data.title, origin: 'directus', alt: catalog.data.image[0].hasOwnProperty('alt') ? catalog.data.image[0].alt : '' };
                                                })
                                                .catch(err => {
                                                    console.log(err);
                                                });
                                        }
                                    });
                                })
                                .catch(err => {
                                    console.log(err);
                                });
                        } else {
                            catalog.vm.$bvToast.toast(`Error al guardar, la imagen ${catalog.data.image[0].name} ya existe.`, {
                                title: `Imagen ya existente`,
                                variant: 'warning',
                                toaster: 'b-toaster-top-center',
                                autoHideDelay: 5000,
                            });
                            commit('toggleActiveCatalogLoading', false);
                            return false;
                        }
                    } else if (catalog.data.image[0].origin == 'directus-update') {
                        image = image;
                    }

                    if (catalog.data.image[0] && catalog.data.image[0].hasOwnProperty('alt') && catalog.data.image[0].origin != 'upload') {
                        await directusApi('PATCH', `files/${catalog.data.image[0].id}`, { alt: catalog.data.image[0].alt })
                            .then(async (resFile: any) => {
                                if (complete_gallery) {
                                    await asyncForEach(complete_gallery, async (complete_gallery_item, complete_gallery_index) => {
                                        await directusApi('PATCH', `files/${complete_gallery_item.id}`, { alt: catalog.data.image[0].alt })
                                            .then(async (resFile: any) => {
                                                complete_gallery[complete_gallery_index] =
                                                {
                                                    ...complete_gallery[complete_gallery_index],
                                                    alt: catalog.data.image[0].alt
                                                }
                                            })
                                            .catch(err => {
                                                console.log(err);
                                            });
                                    });
                                    console.log('Alt updated in all gallery');

                                }
                                console.log('Alt updated succesfully');

                            })
                            .catch(err => {
                                console.log(err);
                            });
                    }
                } catch (error) {
                    console.log('error => no contiene una imagen');
                }

                await directusApi('PATCH', `items/catalogs/${catalogg.data.data.id}`, { image, complete_gallery })
                    .then(async (res: any) => {
                        dispatch('getOne', catalogg.data.data.id);
                        catalog.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
                            title: `Obteniendo información`,
                            variant: 'success',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 5000,
                        });
                    })
                    .catch(err => {
                        console.log(err);
                    });
                // ********************** END adding id of cover to category
                commit('toggleActiveCatalogLoading', false);
                dispatch('getAll', { page: 1 });
                commit('setActiveCatalog', catalogg.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleActiveCatalogLoading', false);
            });

    },

    async getOne({ _, commit }: any, id: any | null = null) {
        commit('toggleActiveCatalogLoading', true);
        if (id != null) {
            await directusApi('GET', `items/catalogs/${id}`)
                .then(res => {
                    commit('setActiveCatalog', res.data.data);
                })
                .catch(err => {
                    console.log(err);
                })
                .finally(() => {
                    commit('toggleActiveCatalogLoading', false);
                });
        } else {
            commit('setActiveCatalog', defaultCatalog);
            commit('toggleActiveCatalogLoading', false);
        }
    },

    async getAll({ _, commit }: any, { search, page }: any) {

        commit('toggleallCatalogsLoading', true);

        let limit = 15;
        let params = '';
        if (search) {
            params += `&filter[title][_contains]=${search}`;
        }

        params += `&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=${limit}&offset=${(page - 1) * limit}`;
        let endpoint = `items/catalogs?${params}`;

        await directusApi('GET', endpoint)
            .then(res => {
                commit('setAllCatalogs', {
                    items: res.data.data,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleallCatalogsLoading', false);
            });
    },

    async putOne({ _, commit, dispatch }: any, { catalogId, catalogData = null }: any) {
        commit('toggleActiveCatalogLoading', true);
        await directusApi('PATCH', `items/catalogs/${catalogId}`, catalogData)
            .then(async () => {
                await directusApi('GET', `items/catalogs/${catalogId}`)
                    .then(res => {
                        dispatch('getAll', { page: 1 });
                        commit('setActiveCatalog', res.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleActiveCatalogLoading', false);
            });
    },

    async deleteOne({ _, commit, dispatch }: any, data: any) {
        await directusApi('DELETE', `items/catalogs/${data.id}`, {})
            .then(async (res: any) => {
                data.vm.$bvToast.toast('Se ha eliminado exitosamente', {
                    title: `Cátalogo eliminado`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
                commit('removeCatalog', data.id);
                // dispatch('getAll');
                dispatch('getAll', { page: 1 });

            })
            .catch(err => {
                console.log(err);
            });
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
